import { render, staticRenderFns } from "./QuestionPaperPackageChoose.vue?vue&type=template&id=44a82b90&scoped=true&"
import script from "./QuestionPaperPackageChoose.vue?vue&type=script&lang=js&"
export * from "./QuestionPaperPackageChoose.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPaperPackageChoose.vue?vue&type=style&index=0&id=44a82b90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a82b90",
  null
  
)

export default component.exports